import { RESOURCE_MANAGER } from "@/config"
import FacePupCompHeader from "../../AvatarDressup/components/FacePupCompHeader"
import FUIcon from "../../../Common/FUIcon"

const VoiceTypeTabContent = (props) => {
    const {
        interrupt,
        voiceType,
        setVoiceType,
        currentDemoId,
        setCurrentDemoId,
        emitByText,
        showType,
        setShowType,
    } = props

    const selectVoice = async function (voice) {
        await interrupt()
        setVoiceType(voice.id)
        setCurrentDemoId('')
    }

    const demoplayer = (voice) => {
        if (!currentDemoId) {
            setCurrentDemoId(voice.id)
            emitByText("你是谁", false, voice.id)
        }
    }

    const toggleFunctionList = () => {
        setShowType(showType === 'audition' ? '' : 'audition')
    }

    return (
        <div className="voice-type-tab">
            <FUIcon
                className="voice-trigger"
                size="48px"
                name={showType === 'audition' ? 'slices/icon_drawer_audition_active.png' : 'slices/icon_drawer_audition.png'}
                style={
                    {
                        cursor: 'pointer',
                        borderRadius: '24px',
                        backgroundColor: '#fff',
                        top: showType ? '-145px' : '-60px'
                    }
                }
                onClick={toggleFunctionList}
            />
            {
                showType === 'audition' && (
                    <div className='voice-list'>
                        <div className="title">
                            <FacePupCompHeader
                                name='语音'
                                Icon={
                                    <FUIcon
                                        size="20px"
                                        name='slices/icon_drawer_audition@2x.png'
                                    />
                                }
                            />
                        </div>
                        <div className="voice-content">
                            {
                                RESOURCE_MANAGER.voiceList.map(voice => (
                                    <div
                                        key={voice.id}
                                        className={
                                            voiceType === voice.id
                                                ? 'voice-item active'
                                                : 'voice-item'
                                        }
                                        onClick={() => selectVoice(voice)}
                                    >
                                        {voice.name}
                                        <FUIcon
                                            name={currentDemoId === voice.id ? 'slices/audition_play.gif' : 'slices/icon_drawer_audition@2x.png'}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                demoplayer(voice)
                                            }}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}
export default VoiceTypeTabContent